import { Component, ElementRef } from '@angular/core';

import { BaseWidget } from '../../BaseWidget/BaseWidget.component';
import { ChartType } from './../../../canvas-chart/canvas-chart-models';
import  {IBoxAndWhiskerDataPoints, IScatterDataPoints, IChartData}  from './../../../canvas-chart/canvas-chart-interfaces';
import { CanvasChartDataAdapter } from './../../../canvas-chart/canvas-chart-data-adapter';
import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';


@Component({
  selector: 'app-widget-help',
  template: `
<h3>Confluence documentation links</h3>

<table class="table table-condensed">
  <tbody>
    <tr>
        <td>
          <a href="https://confluence.micron.com/confluence/display/ITENG/Developer+Guide" target="_blank">Developer Guide</a>
        </td>
    </tr>
    <tr>
      <td>
        <a href="https://confluence.micron.com/confluence/display/ITENG/Guide+to+Creating+a+New+Widget" target="_blank">Creating a new widget</a>
      </td>
    </tr>
      
  </tbody>
</table>






`,
  styles: [``]
})
export class WidgetHelpComponent extends BaseWidget {
  groupData: IChartData[];
  boxAndWhiskerData: IChartData[];
  scatterData: IChartData[];
  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
};
